<template>
  <!-- header_area -->
  <header id="header">

    <div class="header_wrap" ref="header">
      <div style="width: 100vw">

        <q-toolbar class="text-white bg-primary" style="height:60px">
          <div class="live" :class="{ on: dropdown }" @click="dropdown = !dropdown">
            <p>LIVE</p>
          </div>
          <!--<router-link to="/events" class="live">
            <p>LIVE</p>
          </router-link>-->
          <router-link class="logo" to="/home">Bluff &amp; <i>Catch</i><em>Poker News and Live Tournaments</em></router-link>
          <!--<div class="insta">
            <p><a href="https://www.instagram.com/bluffandcatch/" target="_blank"><img src="/statics/img/sns_instagram_color.png"></a></p>
          </div>-->
          <ul class="hbg" @click="toggleDrawer()">
            <li></li>
            <li></li>
            <li></li>
          </ul>
        </q-toolbar>

        <div class="live_lst" v-show="dropdown" @click="dropdown = !dropdown">
          <display-container :section="110"></display-container>
        </div>

        <!--<div class="wsop_wrap">
          <div class="wsop">
            <p class="logo"><img src="/statics/img/logo_wsop.png" alt="WSOP" title="WSOP">2025 World Series of Poker</p>
            <a href="/live/reporting/34?tab=0&day=1">Result</a>
            <a href="/live/reporting/34?tab=0&day=0">Issue</a>
          </div>
        </div>-->

        <!--<div class="gnb">
          <q-tabs
            v-model="tab"
            inline-label
            class=""
            active-color="secondary"
            active-bg-color="white"
            indicator-color="secondary"
            :ripple="false"
          >
            <q-route-tab to="/news" name="NEWS" label="News" exact onclick="gtag('event', '버튼클릭', {'event_category': 'GNB','event_label': 'NEWS'})" :class="{on : isCurrentRouteName('Article')}"/>
            <q-route-tab to="/events" name="LIVE EVENTS" label="Live Events" exact onclick="gtag('event', '버튼클릭', {'event_category': 'GNB','event_label': 'LIVE EVENTS'})" :class="{on : isCurrentRouteName('Events') || isCurrentRouteName('LiveReporting') || isCurrentRouteName('ReportingArticle')}"/>
            <q-route-tab to="/tournaments" name="TOURNAMENTS" label="Tournaments" exact onclick="gtag('event', '버튼클릭', {'event_category': 'GNB','event_label': 'TOURNAMENTS'})" :class="{on : isCurrentRouteName('Tournaments') || isCurrentRouteName('Tournament') }"/>
            <q-route-tab to="/gallery" name="GALLERY" label="Gallery" exact onclick="gtag('event', '버튼클릭', {'event_category': 'GNB','event_label': 'GALLERY'})" :class="{on : isCurrentRouteName('Gallery') || isCurrentRouteName('GallerySeries') || isCurrentRouteName('GallerySeriesAlbum') }" class=""/>
            <q-route-tab to="/market" name="MARKET" label="Infographic" exact onclick="gtag('event', '버튼클릭', {'event_category': 'GNB','event_label': 'MARKET'})" :class="{on : isCurrentRouteName('Market')}"/>
            <q-route-tab to="/poll" name="POLL" label="Poll" exact onclick="gtag('event', '버튼클릭', {'event_category': 'GNB','event_label': 'POLL'})" />
            <q-route-tab to="/shop" name="SHOP" label="Shop" class="" exact target="_blank"/>
          </q-tabs>
        </div>-->

      </div>
    </div>

    <!--<transition-group
      appear
      enter-active-class="animated fadeInDown faster"
      leave-active-class="animated slideOutUp faster"
      >
      <div :class="{ fixed: fixed }" v-if="isHeaderVisibleDefault()" key="COMMON">

        <div class="header_wrap transform">
          <div :class="" style="width: 100vw">

            <q-toolbar class="text-white bg-primary header" style="height:60px;">
              <div class="live" :class="{ on: dropdown }" @click="dropdown = !dropdown">
                <p>LIVE</p>
              </div>
              <router-link class="logo" to="/home">Bluff &amp; <i>Catch</i><em>Poker News and Live Tournaments</em></router-link>
              <div class="insta">
                <p><a href="https://www.instagram.com/bluffandcatch/" target="_blank"><img src="/statics/img/sns_instagram_color.png"></a></p>
              </div>
              <ul class="hbg" @click="toggleDrawer()">
                <li></li>
                <li></li>
                <li></li>
              </ul>
            </q-toolbar>

            <div class="live_lst" v-show="dropdown" @click="dropdown = !dropdown">
              <display-container :section="110"></display-container>
            </div>

            <transition
              appear
              enter-active-class="animated slideInDown faster"
              leave-active-class="animated slideOutUp faster"
            >
              <div class="gnb" v-show="!fixed || (fixed && scrollInfo.position < headerTopPosition.COMMON) || direction === 'up'">
                <q-tabs
                  v-model="tab"

                  inline-label
                  class=""
                  active-color="secondary"
                  active-bg-color="white"
                  indicator-color="secondary"
                  :ripple="false"
                >
                  <q-route-tab to="/news" name="NEWS" label="News" exact onclick="gtag('event', '버튼클릭', {'event_category': 'GNB','event_label': 'NEWS'})" :class="{on : isCurrentRouteName('Article')}"/>
                  <q-route-tab to="/events" name="LIVE EVENTS" label="Live Events" exact onclick="gtag('event', '버튼클릭', {'event_category': 'GNB','event_label': 'LIVE EVENTS'})" :class="{on : isCurrentRouteName('Events') || isCurrentRouteName('LiveReporting') || isCurrentRouteName('ReportingArticle')}"/>
                  <q-route-tab to="/tournaments" name="TOURNAMENTS" label="Tournaments" exact onclick="gtag('event', '버튼클릭', {'event_category': 'GNB','event_label': 'TOURNAMENTS'})" :class="{on : isCurrentRouteName('Tournaments') || isCurrentRouteName('Tournament') }"/>
                  <q-route-tab to="/gallery" name="GALLERY" label="Gallery" exact onclick="gtag('event', '버튼클릭', {'event_category': 'GNB','event_label': 'GALLERY'})" :class="{on : isCurrentRouteName('Gallery') || isCurrentRouteName('GallerySeries') || isCurrentRouteName('GallerySeriesAlbum') }" class=""/>
                  <q-route-tab to="/market" name="MARKET" label="Infographic" exact onclick="gtag('event', '버튼클릭', {'event_category': 'GNB','event_label': 'MARKET'})" :class="{on : isCurrentRouteName('Market')}"/>
                  <q-route-tab to="/poll" name="POLL" label="Poll" exact onclick="gtag('event', '버튼클릭', {'event_category': 'GNB','event_label': 'POLL'})" />
                  <q-route-tab to="/shop" name="SHOP" label="Shop" class="" exact target="_blank"/>
                </q-tabs>
              </div>
            </transition>

          </div>
        </div>
      </div>
    </transition-group>-->


    <q-scroll-observer @scroll="handleScroll" />

  </header>
  <!-- //header_area -->
</template>

<script>
  import Vue from 'vue'
  import {QToolbar,QToolbarTitle,QBtn,QSpace,QTabs,QRouteTab,QSlideTransition,QScrollObserver,QCarousel,QCarouselControl,QCarouselSlide,QLayout,QHeader,QFooter,QPageContainer,QPage, QDialog} from 'quasar'
  import {Dialog, Popover, Dropdown, DropdownMenu, DropdownItem} from 'element-ui'
  import DisplayContainer from '../components/DisplayContainer'
  import CommonComputed from 'src/_mixins/CommonComputed'
  import CommonMethods from 'src/_mixins/CommonMethods'
  import { mapGetters } from 'vuex'
  export default {
    components: {
      DisplayContainer,
      QToolbar,
      QToolbarTitle,
      QBtn,
      QSpace,
      QTabs, QRouteTab,
      QSlideTransition,
      QScrollObserver,
      QCarousel,
      QCarouselControl,
      QCarouselSlide,
      QLayout,QHeader,QFooter,QPageContainer,QPage,
    },
    data () {
      return {
        tab: '/chart',
        openChart: false,
        slide: 1,
        scrollInfo: {},
        direction: 'down',
        fixed: false,
        loadedCnt: 0,
        dropdown: false,
        dialogs: {
          'corp': { open: false }
        },
        headerTopPosition: {
          'ChartView': 800,
          'TeamDetail': 600,
          'ContentsDetail': 600,
          'CompareDetail': 500,
          'CardDetail': 800,
          'COMMON': 600
        }
      }
    },
    computed: {
      ...CommonComputed,
      ...mapGetters([
        'isToastBannerSmallSize'
      ]),
      getAccess () {
        return 'mobile'
      }
    },
    methods: {
      ...CommonMethods,
      handleScroll (info) {
        this.scrollInfo = info
        this.direction = info.directionChanged ? info.position > info.inflexionPosition ? 'down' : 'up' : info.position < this.getTargetPosition() ? 'down' : this.direction  // ios 13 scroll bounce issue fixed
        this.fixed = info.position > this.$refs.header.offsetTop

      },
      isCurrentRouteName (name) {
        return this.getRouteName === name
      },
      isHeaderVisible (name) {
        return this.isCurrentRouteName(name)
          && this.fixed
          && this.direction === 'down'
          && this.headerTopPosition[name] < this.scrollInfo.position
      },
      isHeaderVisibleDefault () {
        return !(
          this.isHeaderVisible('ChartView')
          || this.isHeaderVisible('TeamDetail')
          || this.isHeaderVisible('ContentsDetail')
          || this.isHeaderVisible('CompareDetail')
          || this.isHeaderVisible('CardDetail')
        )
        && this.fixed
        && this.scrollInfo.position > this.getTargetPosition()
      },
      toggleDrawer () {
        this.$emit('drawer')
      },
      getTargetPosition (name) {
        name = name ? name : this.getRouteName
        const target = this.headerTopPosition[name]
        const targetPosition = target ? target : this.headerTopPosition.COMMON
        return targetPosition
      },
    }
  }
</script>

<style>
  .q-tab {
    padding: 0 !important;
    min-height: 40px !important;
    background-color: transparent !important;
		position: relative !important;
  }
	.gnb .q-tabs__content {
		overflow: visible;
  }
	.gnb .q-tabs__content .q-tab.on {
		color: var(--q-color-secondary) !important;
  }
  .q-tab__content {
    overflow: visible !important;
    overflow-y: visible !important;
    width: auto !important;
    padding: 0 !important;
  }
  .q-tab__content--inline {
    height: 40px;
    padding: 0 6px !important;
  }
  .new .q-tab__content--inline:after {
    content: "";
    display: inline-block;
    width: 4px;
    height: 4px;
    border-radius: 100%;
    background: #00b404;
    position: absolute;
    top: 30%;
		right: 3px;
  }
  .q-tab--inactive {
    opacity: 1;
  }
  .q-tab__indicator {
    height: 7px !important;
    width: 7px !important;
    border-radius: 100% !important;
    right: 50% !important;
    left: calc(50% - 3.5px) !important;
    margin-bottom: 6px;
    display: none;
  }
  .q-toolbar.header {
    z-index: 5;
  }
  .q-toolbar .live {
    position: absolute;
    color: #fff;
    left: 20px;
    z-index: 1;
  }
  .q-toolbar .live.on:after {
    content: "";
    display: inline-block;
    width: 6px;
    height: 6px;
    background: #ad1dc8;
    position: absolute;
    top: 100%;
    left: 50%;
    transform: translate(-50%, -50%) rotate(45deg);
    z-index: -1;
  }
  .q-toolbar .live p {
    font-family: 'Roboto Slab';
    font-weight: 900;
    font-size: 14px;
    line-height: 1.0em;
    padding: 5px 12px;
    border-radius: 5.0em;
    background: linear-gradient(to right, #603afe, #fc0192);
  }
  .header_wrap .live_lst {
    position: absolute;
    top: 60px;
    left: 0;
    display: block;
    width: 100vw;
    height: auto;
    background: linear-gradient(to right, #603afe, #fc0192);
    z-index: 5;
  }
  .header_wrap .live_lst .m-show p {
    display: block;
  }
  .header_wrap .live_lst a {
    display: flex;
    align-items: center;
    font-family: 'Roboto Slab','SUIT Variable';
    font-weight: 900;
    font-size: 16px;
    color: #fff;
    line-height: 1.2em;
    padding: 18px 50px 18px 20px;
    border-bottom: 1px solid rgba(255,255,255,0.3);
    position: relative;
    text-align: left;
  }
  .header_wrap .live_lst a.router-link-active {
    padding: 0;
  }
  .header_wrap .live_lst a i {
    font-family: 'SUIT Variable';
    font-weight: 400;
    padding: 0 5px;
  }
  .header_wrap .live_lst a sup {
    font-family: 'SUIT Variable';
    font-size: 0.85rem;
    font-weight: 600;
  }
  /*.header_wrap .live_lst a p:after {
    content: "March";
    font-family: 'SUIT Variable';
    font-size: 0.85rem;
    font-weight: 600;
    line-height: 1.2em;
    margin-left: 3px;
  }*/
  .header_wrap .live_lst p a:after {
    content: "";
    display: inline-block;
    width: 9px;
    height: 9px;
    border: solid #fff;
    border-width: 2px 2px 0 0;
    position: absolute;
    top: 50%;
    right: 22px;
    transform: rotate(45deg) translate(-50%, -50%);
  }
  .header_wrap .live_lst a.now:before {
    content: "NOW";
    font-family: SUIT Variable;
    font-size: 0.55em;
    font-weight: 900;
    color: rgba(255,255,255,1.0);
    line-height: 1.0em;
    position: relative;
    margin-right: 8px;
    background: rgba(255,255,255,0.35);
    padding: 6px;
    border-radius: 5.0em;
  }
  .header_wrap .live_lst a.ongoing:before {
    content: "Ongoing";
    font-family: SUIT Variable;
    font-size: 0.55em;
    font-weight: 900;
    color: rgba(255,255,255,1.0);
    line-height: 1.0em;
    position: relative;
    margin-right: 8px;
    background: rgba(255,255,255,0.35);
    padding: 6px;
    border-radius: 5.0em;
  }
  .header_wrap .live_lst a.upcoming {
    background: linear-gradient(to right, #372486, #940056);
  }
  .header_wrap .live_lst a.upcoming:before {
    content: "Upcoming";
    font-family: SUIT Variable;
    font-size: 0.55em;
    font-weight: 900;
    color: rgba(255,255,255,1.0);
    line-height: 1.0em;
    margin-right: 10px;
    background: rgba(255,255,255,0.35);
    padding: 6px;
    border-radius: 5.0em;
  }
  .header_wrap .live_lst a.end {
    background: linear-gradient(to right, #444, #666);
  }
  .header_wrap .live_lst a.end:before {
    content: "Finished";
    font-family: SUIT Variable;
    font-size: 0.55em;
    font-weight: 900;
    color: rgba(255,255,255,1.0);
    line-height: 1.0em;
    margin-right: 10px;
    background: rgba(255,255,255,0.35);
    padding: 6px;
    border-radius: 5.0em;
  }
  .header_wrap .live_lst p:last-child a {
    border-bottom: 0;
  }
  .q-toolbar .insta {
    position: absolute;
    right: 54px;
  }
  .q-toolbar .insta p {
    padding: 5px 10px;
  }
  .q-toolbar .insta p img {
    width: 22px;
    filter: brightness(10.0);
  }
  .q-toolbar .logo {
    text-align: center;
    font-family: 'Spectral';
    font-weight: 400;
    font-size: 29px;
    color: #fff;
    letter-spacing: -0.07em;
    line-height: 1.0em;
    transition: .15s;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
  .q-toolbar .logo i {
    color: #00ff64;
  }
  .q-toolbar .logo em {
    display: block;
    font-family: 'Rokkitt';
    font-size: 9px;
    font-style: normal;
    letter-spacing: 0.0em;
    line-height: 1.0em;
    transition: .15s;
  }
  .q-toolbar .hbg {
    display: block;
    width: 60px;
    height: 60px;
    padding: 20px;
    position: absolute;
    right: 0;
  }
  .q-toolbar .hbg li {
    display: inline-block;
    width: 25px;
    height: 1.5px;
    background: #fff;
    position: absolute;
    right: 20px;
    top: 50%;
    transform: translate(0, -50%);
  }
  .q-toolbar .hbg li:first-child {
    top: 35%;
  }
  .q-toolbar .hbg li:nth-child(2) {
    width: 20px;
  }
  .q-toolbar .hbg li:last-child {
    top: 65%;
  }
  .q-toolbar a img {
    width: 175px;
    height: auto;
  }
  .q-pt-sm { padding-top: 4px !important;}
  .inner {
    max-width: 100vw !important;
  }
  .fixed {
    z-index: 4;
    top: 0 !important;
  }
  .header_wrap {
    width: 100vw;
    height: 60px;
		position: relative;
    z-index: 100;
  }
  .header_wrap > div {
    position: fixed;
    top: 0;
  }
  .header_wrap .header {
    z-index: 5;
  }
  .header_wrap .wsop {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 40px;
    background-color: #dd0000;
    padding: 0 1.0vw;
    z-index: 4;
  }
  .header_wrap .wsop p {
    display: flex;
    align-items: center;
    font-size: 15px;
    font-weight: 800;
    color: #fff;
    letter-spacing: -0.04em;
    line-height: 1.0em;
    margin-right: 5px;
  }
  .header_wrap .wsop p img {
    width: 19px;
    margin-right: 5px;
  }
  .header_wrap .wsop a {
    font-size: 12px;
    font-weight: 800;
    color: #fff;
    letter-spacing: -0.02em;
    line-height: 1.0em;
    text-transform: uppercase;
    padding: 7px 17px 7px 13px;
    background: rgba(0,0,0,1.0);
    border-radius: 5.0em;
    margin: 0 2px;
    position: relative;
  }
  .header_wrap .wsop a:after {
    content: "";
    position: absolute;
    top: 22%;
    right: 9px;
    display: inline-block;
    width: 4px;
    height: 4px;
    border-radius: 100%;
    background: #ff0000;
  }
  .header_wrap .gnb {
    font-family: 'Roboto Slab';
    height: 40px;
    background-color: #fff;
    padding: 0 1.0vw;
    white-space: nowrap;
    width: 100vw;
    overflow-x: auto;
    overflow-y: hidden;
    position: relative;
    z-index: 4;
  }
  .header_wrap .gnb .q-tabs__arrow {
    display: none;
  }
  .header_wrap .gnb .q-tab__content--inline {
    padding: 0 2.4vw !important;
  }
  .header_wrap .gnb .q-tab__label {
    font-size: 16px;
    font-weight: 800;
    text-transform: capitalize;
    letter-spacing: -0.02em;
  }
  /*
  .header_wrap .gnb a.link {
    font-size: 14px;
    font-weight: 900;
    color: #000;
    letter-spacing: -0.02em;
    min-height: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex: 1 1 auto;
  }
  */
  .header_wrap .gnb a.link span {
    line-height: 1.715em;
  }
  .header_wrap .gnb a.link span:after {
    content: "";
    display: inline-block;
    width: 4px;
    height: 4px;
    border-radius: 100%;
    background: #00b404;
    position: absolute;
    top: 30%;
    margin-left: 1px;
  }
  .ad_wrap.head {
    min-width: 1100vw;
    margin: 40px auto;
    text-align: center;
  }
  .ad_wrap.head {
    min-width: 100vw;
    margin: 0 auto !important;
    text-align: center;
  }
  /*.ad_wrap.head .inner img {
    width: 320px;
    height: 50px;
  }*/

  /* 상단 고정 - 기본 */
  .logo_short {
    width: 34px;
    overflow: hidden;
  }
  .header_wrap.transform {
    width: 100vw;
    background-color: unset !important;
    min-height: unset !important;
  }
  .header_wrap.transform .card_ranking_toolbar {
    background-color: unset !important;
  }
  .header_wrap.transform .card_ranking_toolbar .sBox {
    background-color: #f1f1f1 !important;
    border-radius: 3px;
  }
  .header_wrap.transform .card_ranking_toolbar .lst .num {
    width: 20px !important;
    padding-left: 10px !important;
    padding-right: 10px !important;
  }
  .header_wrap.transform .card_ranking_toolbar .lst .name {
    width: 48vw !important;
    max-width: 48vw !important;
  }

  /* 상단 고정 - 공통 */
  .fixmenu_wrap {
    display: table;
    width: 100vw;
    min-height: 60px;
    background: #fff;
    text-align: center;
    box-shadow: 0 5px 10px rgba(0, 0, 0, 0.1);
    position: relative;
    z-index: 2002;
  }
  [data-f-id="pbf"] {
    display: none;
  }
</style>
